import { useTranslation } from 'react-i18next';
import { localizedServerContent } from '../../../localization/presentationLanguage';

export default function ClashMetaStrip({
  styles,
  streak,
  backendProfile,
  profileTitle,
  profileSubtitle,
}) {
  const { t } = useTranslation('zodiacClash');
  return (
    <div style={styles.metaStripRow}>
      <div style={styles.metaStripCard}>
        <div style={styles.metaStripLabel}>{t('currentStreak')}</div>
        <div style={styles.metaStripValue}>
          🔥 {streak?.current > 0 ? t('activeDay', { count: streak.current }) : t('streakInactive')}
        </div>
        <div style={styles.metaStripSub}>
          {t('bestStreak')}: {streak?.best || 0}
        </div>
      </div>

      <div style={styles.metaStripCard}>
        <div style={styles.metaStripLabel}>{t('yourProfile')}</div>
        <div style={styles.metaStripValue}>
          {localizedServerContent(profileTitle, t('strategicMind'))}
        </div>
        <div style={styles.metaStripSub}>
          {localizedServerContent(profileSubtitle, t('strategicSubtitle'))}
          {backendProfile?.totalVotes ? ` · ${t('decisionsAnalyzed', { count: backendProfile.totalVotes })}` : ''}
        </div>
      </div>

      
    </div>
  );
}
